export enum LoginMethod {
  ByPhone = 'by-phone',
  ByQrCode = 'by-qrcode',
  ByAccount = 'by-account',
}

export enum LoginAccountType {
  Sports = 'sports', // 运动号
  Cooperation = 'cooperation', // 合作号
}

export interface ILoginResult {
  auth_token: string
}
